import {
  canConvertExceedingPackageValueAsBalance,
  invoiceStatusConfig,
  packageByStatus,
} from 'entities';

import { useUser } from 'hooks';

import { usePackage } from '../context';

export function usePackageOptionsPermissions() {
  const user = useUser();

  const { data } = usePackage();

  const canConvert = [
    user.team.isInvoiceTeam,
    user.type === 'LEADER',
    canConvertExceedingPackageValueAsBalance(data),
  ].every(Boolean);

  const canCancel = [
    packageByStatus[data.status].canCancel,
    user.team.isInvoiceTeam,
    user.type === 'LEADER',
    !data.projects.length,
    data.invoices.every((inv) => inv.status === invoiceStatusConfig.canceled.code),
  ].every(Boolean);

  return {
    canConvert,
    canCancel,
  };
}
